module.exports = __webpack_public_path__ + "img/licence.7eee56ba.png";